<template>
  <div class="col-12 pl-0 ml-0">
    <v-row>
      <v-col class="pb-0">
        <p class="title pl-0 ml-0 mb-0 mt-5">결제 하기</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_name"
          label="쇼핑몰명"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_manager"
          label="담당자명"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_phone"
          label="핸드폰번호"
          single-line
          outlined
          dense
          autocomplete="off"
          @keydown="M.checkNumber($event)"
          @keypress="M.replaceNumber($event, 12, false)"
          @blur="M.replaceNumber($event, 12, false)"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_email"
          label="이메일주소"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-6 pt-0 pb-0">
        <v-select
          v-model="ordersPayload.mall_order_type"
          :items="periodList"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col class="row justify-end pa-0 text-center mr-3">
        <v-btn
          large
          color="primary"
          width="382"
          @click.prevent="execOrder"
          class="pl-0 pr-0"
          height="40"
          >결제하기</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      periodSelected: "",
      periodList: [],
      ordersPayload: {
        mall_order_type: "",
        mall_name: "",
        mall_manager: "",
        mall_phone: "",
        mall_email: "",
      },
    };
  },

  mixins: [CommonMixin],
  methods: {
    getOrdersTypes: async function() {
      this.periodList = [
        {
          text: "개월 수 선택",
          value: "",
        },
      ];
      let res = await M.api(M.entry("/get/orders/types"));
      if (res) {
        res.forEach((data) => {
          let option = {
            text: data.order_name,
            value: data.order_type,
          };
          this.periodList.push(option);
        });
      }
    },
    execOrder: async function() {
      if (this.ordersPayload.mall_name === "") {
        alert("쇼핑몰명을 확인해주세요.");
        return false;
      }
      if (this.ordersPayload.mall_manager === "") {
        alert("담당자명을 확인해주세요.");
        return false;
      }
      if (!this.ordersPayload.mall_phone) {
        alert("핸드폰 번호를 입력해주세요.");
        return false;
      }
      if (!this.ordersPayload.mall_email) {
        alert("이메일 주소를 입력해주세요. ");
        return false;
      }

      if (this.ordersPayload.mall_order_type === "") {
        alert("사용하실 개월 수를 선택해주세요.");
        return false;
      }

      let phone_number_check_result = M.isPhoneNumber(
        this.ordersPayload.mall_phone
      );
      if (
        !phone_number_check_result ||
        this.ordersPayload.mall_phone.length >= 12
      ) {
        alert("핸드폰 번호를 확인해주세요.");
        return false;
      }

      let mail_check_result = M.isMail(this.ordersPayload.mall_email);
      if (!mail_check_result) {
        alert("이메일 주소를 확인해주세요.");
        return false;
      }

      let res = await M.api(M.entry("/post/orders"), this.ordersPayload);
      if (Object.prototype.hasOwnProperty.call(res, "confirmation_url")) {
        window.location.href = res.confirmation_url;
      }
    },
  },
  created: async function() {
    try {
      let data = await M.api(M.entry("/get/orders/latest"), {});
      if (data) {
        this.ordersPayload.mall_name = data.mall_name;
        this.ordersPayload.mall_manager = data.mall_manager;
        this.ordersPayload.mall_phone = data.mall_phone;
        this.ordersPayload.mall_email = data.mall_email;
      }
    } catch {
      this.ordersPayload.mall_name = "";
      this.ordersPayload.mall_manager = "";
      this.ordersPayload.mall_phone = "";
      this.ordersPayload.mall_email = "";
    }
  },
  mounted: function() {
    this.getOrdersTypes();
  },
};
</script>
